/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useEffect, useRef } from 'react';
import type { OtpMountBehaviour } from './otp/types';

export interface UseAutoRequestOtpOptions {
  behaviour: OtpMountBehaviour;
  requestOtp: () => void;
  startTimer: () => void;
}

export function useAutoRequestOtp({
  behaviour,
  requestOtp,
  startTimer,
}: UseAutoRequestOtpOptions): void {
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (hasRunRef.current || behaviour === 'none') return;
    hasRunRef.current = true;

    if (behaviour === 'request') {
      requestOtp();
      return;
    }

    startTimer();
  }, [behaviour, requestOtp, startTimer]);
}
